$(document).ready(function () {
    // Tabs
    $(".tabs-nav-trigger").on("click", function () {
        const container = $(this).closest(".tabs");
        const targetId = $(this).data("target");

        container.find(".tabs-nav-trigger").removeClass("active");
        $(this).addClass("active");
        container.find(".tabs-target").hide();
        container.find('.tabs-target[data-target="' + targetId + '"]').show();
    });
});
